import useUserStore from 'graph/state/query-hooks/use-user';
import useAssignmentsStore from 'graph/state/query-hooks/use-assignments-store';
import usePageStore from '@monorepo/shared/src/graph/state/query-hooks/use-page-store';
import { BookType } from '@monorepo/shared/src/graph/schema-generated-types-student';

const useBookAccess = () => {
  const [user] = useUserStore();

  const [{ books, loading: booksLoading }] = usePageStore(BookType.LETTER_BOOK);
  const [{ assignments, isLoading: assignmentsLoading }] = useAssignmentsStore();

  let characterMap;
  if (books?.length) {
    characterMap = books.reduce(
      (a, book) => ({
        ...a,
        [book?.characters?.[0]?.id]: book?.id,
        [book?.characters?.[1]?.id]: book?.id,
      }),
      {}
    );
  }

  const accessBookAfterAssignment = user?.me?.classrooms?.[0].settings?.find(
    (x) => x.setting === 'accessBookAfterAssignment'
  )?.value?.enabled;

  const accessibleBooks: any[] = [];
  if (accessBookAfterAssignment && assignments && characterMap) {
    assignments.forEach((element) => {
      accessibleBooks.push(characterMap[element.characterId]);
    });
  }

  return {
    accessBookAfterAssignment,
    accessibleBooks,
    loading: booksLoading || assignmentsLoading,
  };
};

export default useBookAccess;
